import { phpRequest } from "./phpRequest";

export const updateCompanyTokenAPI = async (companyId) => {
  const data = await phpRequest.post("/company-token/update", {
    company_id: companyId,
  });
  return data.token;
};
